export default function Footer() {
  return (
    <footer className="mt-16 border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-8 text-sm text-slate-500 lg:px-6">

        {/* 💡 약관 및 정책 링크 영역 (신규 추가) */}
        <div className="mb-6 flex flex-wrap gap-6 border-b border-slate-100 pb-6 text-sm">
          <a href="/terms" className="hover:text-slate-900 transition-colors">이용약관</a>
          {/* 법적 고지에 따라 개인정보처리방침은 굵게 표시하는 것이 좋습니다 */}
          <a href="/privacy" className="font-bold text-slate-800 hover:text-slate-900 transition-colors">개인정보처리방침</a>
          <a href="/refund" className="hover:text-slate-900 transition-colors">교환/환불 정책</a>
        </div>

        {/* 💡 사업자 정보 영역 */}
        <div className="mb-6 space-y-2">
          <p className="text-base font-bold text-slate-700">
            엠지네트워크 주식회사
          </p>
          <div className="flex flex-wrap gap-x-3 gap-y-1">
            <span>대표자명 : 이종화</span>
            <span className="hidden text-slate-300 sm:inline">|</span>
            <span>사업자등록번호 : 209-81-67820</span>
            <span className="hidden text-slate-300 sm:inline">|</span>
            <span>전화 : 02-3786-4377</span>
          </div>
          <p>
            사업장 주소 : 서울특별시 영등포구 영등포로 147, 801호(당산동1가, 당산빌딩)
          </p>
        </div>

        {/* 💡 저작권 영역 */}
        <div className="pt-6 border-t border-slate-100">
          © 2026 MG Quick Flower. All rights reserved.
        </div>

      </div>
    </footer>
  )
}